import React from 'react';
import './DragHandle.css';

function DragHandle({ hasSubtasks, listeners, attributes }) {
  return (
    <span
      className={`task-drag-handle ${hasSubtasks ? 'task-drag-handle-with-subtasks' : 'task-drag-handle-no-subtasks'}`}
      {...listeners}
      {...attributes}
      onMouseDown={(e) => {
        listeners?.onMouseDown?.(e);
        e.stopPropagation();
      }}
      onPointerDown={(e) => {
        listeners?.onPointerDown?.(e);
        e.stopPropagation();
      }}
      onClick={(e) => {
        listeners?.onClick?.(e);
        e.stopPropagation();
      }}
    >
      <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="1.5" cy="1.5" r="1" fill="currentColor"/>
        <circle cx="4.5" cy="1.5" r="1" fill="currentColor"/>
        <circle cx="1.5" cy="5" r="1" fill="currentColor"/>
        <circle cx="4.5" cy="5" r="1" fill="currentColor"/>
        <circle cx="1.5" cy="8.5" r="1" fill="currentColor"/>
        <circle cx="4.5" cy="8.5" r="1" fill="currentColor"/>
      </svg>
    </span>
  );
}

export default DragHandle;


